export default __webpack_public_path__ + "static/media/logo--1password.d3c32f48.png";